import { Component } from '@angular/core';

@Component({
  selector: 'app-behaviour-tracker-detail-screen-shimmer-loader',
  templateUrl: './behaviour-tracker-detail-screen-shimmer-loader.component.html',
  styleUrls: ['./behaviour-tracker-detail-screen-shimmer-loader.component.css']
})
export class BehaviourTrackerDetailScreenShimmerLoaderComponent {

}
